import React from "react";
import { Car, MapPinOff, AlertTriangle } from "lucide-react";

// Distance from the trainer's base address to the learner's pickup. Every
// failure mode gets explicit copy — a blank cell would read as "0 km away".
const COPY = {
  no_pickup: { text: "Pickup address not specified", icon: MapPinOff },
  unusable_pickup: { text: "Pickup too vague to locate", icon: AlertTriangle },
  not_found: { text: "Couldn't locate this address", icon: AlertTriangle },
  error: { text: "Distance unavailable", icon: AlertTriangle },
  pending: { text: "Calculating…", icon: Car },
};

export const PickupDistance = ({ distance, onAddBase, testId }) => {
  if (!distance || distance.status === "unconfigured") return null;

  if (distance.status === "no_base") {
    return (
      <button type="button" onClick={onAddBase}
              className="inline-flex items-center gap-1 text-[11px] text-primary hover:underline"
              data-testid={testId}>
        <MapPinOff className="w-3 h-3" /> Add your base address to see distances
      </button>
    );
  }

  if (distance.status === "ok") {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] text-muted-foreground" data-testid={testId}>
        <Car className="w-3 h-3 shrink-0" />
        <span className="font-medium text-foreground">{distance.km} km</span>
        {distance.minutes ? <span>· ~{distance.minutes} min drive</span> : null}
      </span>
    );
  }

  const fallback = COPY[distance.status] || COPY.error;
  const Icon = fallback.icon;
  return (
    <span className="inline-flex items-center gap-1 text-[11px] text-muted-foreground" data-testid={testId}>
      <Icon className="w-3 h-3 shrink-0" /> {fallback.text}
    </span>
  );
};

export default PickupDistance;
